import { DoceboUserInfo } from '@/lib/DoceboAPI';
import { DisplayConditions } from '@/types';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

interface LocalState {
  branchGroups: { [branchGroupId: string]: number[] };
  userInfo: DoceboUserInfo | null;
}

Vue.use(Vuex);

const namespaced = true;

const localState: LocalState = {
  userInfo: null,
  branchGroups: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<LocalState, any> = {
  hasUserGotAdditionalField: (state) => (additionalField: string) => {
    return (
      state.userInfo?.data.additional_fields.find(
        (field) => field.title === additionalField
      )?.value === 1
    );
  },

  isUserInBranchGroup: (state) => (branchGroupId: string) => {
    return !!state.userInfo?.data.branches.find((branch) =>
      state.branchGroups[branchGroupId].includes(branch.id)
    );
  },

  isCatalogueWithinUserConditions: (_state, localGetters) => (
    catalogueConditions: DisplayConditions
  ): boolean => {
    let isWithinConditions = true;
    catalogueConditions.forEach((displayCondition) => {
      let conditionState = true;
      switch (displayCondition[0]) {
        case 'additionalField':
          conditionState = localGetters.hasUserGotAdditionalField(
            displayCondition[2]
          );
          break;
        case 'branchGroup':
          conditionState = localGetters.isUserInBranchGroup(
            displayCondition[2]
          );
          break;
        default:
          break;
      }
      const operator = displayCondition[1];
      if (operator === '===' && !conditionState) isWithinConditions = false;
      else if (operator === '!==' && conditionState) isWithinConditions = false;
    });
    return isWithinConditions;
  },
};

const mutations: MutationTree<LocalState> = {
  SET_BRANCH_GROUPS: (
    state,
    branchGroups: { [branchGroupId: string]: number[] }
  ) => Vue.set(state, 'branchGroups', branchGroups),

  SET_USER_INFO: (state, userInfo: DoceboUserInfo) =>
    Vue.set(state, 'userInfo', userInfo),
};

const actions: ActionTree<LocalState, unknown> = {
  SET_BRANCH_GROUPS: (
    context,
    branchGroups: { [branchGroup: string]: number[] }
  ): void => context.commit('SET_BRANCH_GROUPS', branchGroups),

  SET_USER_INFO: (context, payload: DoceboUserInfo): void =>
    context.commit('SET_USER_INFO', payload),
};

export { namespaced, localState as state, getters, mutations, actions };
